const RATE_PATTERN = /^\d+(?:[.,]\d{1,2})?$/;
export function parseRate(value) {
    const trimmed = value.trim();
    if (!RATE_PATTERN.test(trimmed))
        return null;
    const [whole, fraction = ''] = trimmed.replace(',', '.').split('.');
    const hundredths = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
    return Number.isSafeInteger(hundredths) ? hundredths : null;
}
export function formatHundredths(value) {
    const sign = value < 0 ? '-' : '';
    const absolute = Math.abs(value);
    return `${sign}${Math.floor(absolute / 100)}.${String(absolute % 100).padStart(2, '0')}`;
}
export function validateRate(value) {
    const parsed = parseRate(value);
    if (parsed === null)
        return 'Введите 0 или число с максимум двумя знаками после запятой';
    if (parsed > 0 && parsed < 10)
        return 'Минимальный темп — 0,1 регистрации в секунду';
    return null;
}
export function validateRateSum(normalRate, fastRate, maxTotalRate) {
    const normal = parseRate(normalRate);
    const fast = parseRate(fastRate);
    const maximum = parseRate(maxTotalRate);
    if (normal === null || fast === null || maximum === null)
        return null;
    if (normal + fast <= maximum)
        return null;
    return `Сумма темпов не может превышать ${formatHundredths(maximum)} регистрации в секунду`;
}
const RATE_FIELDS = ['normal_rate', 'fast_rate'];
export function buildRatePatch(base, draft, touched) {
    const patch = {};
    for (const field of RATE_FIELDS) {
        if (!touched.has(field))
            continue;
        const value = parseRate(draft[field]);
        const baseValue = parseRate(base[field]);
        if (value === null || value === baseValue)
            continue;
        patch[field] = formatHundredths(value);
    }
    return patch;
}
export function rateWarning(base, patch) {
    const changes = RATE_FIELDS.flatMap((field) => {
        if (patch[field] === undefined)
            return [];
        const previous = parseRate(base[field]);
        const next = parseRate(patch[field]);
        return previous === null || next === null ? [] : [{ previous, next }];
    });
    if (changes.some(({ previous, next }) => previous > 0 && next === 0))
        return 'pause';
    const acceleratesStrongly = changes.some(({ previous, next }) => previous > 0 && next >= previous * 5 && next - previous >= 100);
    return acceleratesStrongly ? 'acceleration' : null;
}
